<template>
  <div class="third robot-basic-info">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="changeComponent">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>-->
          <!-- <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">机器人基础信息配置</span>
        </div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="commit" v-el-disabel-repeat-click>保存</el-button>
          <el-button class="btn-two" type="default" @click="reset">重置</el-button>
        </div>
      </div>
      <el-form
        :model="otherForm"
        :rules="rules"
        ref="otherForm"
        label-width="86px"
        :show-message="false"
        @validate="validateValue"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top:57px">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-two-line">
                <el-form-item label="机器人名称" prop="name">
                  <el-input
                    class="list-input"
                    :maxlength="20"
                    v-model.trim="otherForm.name"
                    placeholder="请输入"
                    :disabled="title === '编辑'"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="list-two-line">
                <el-form-item label="未知问题回答" prop="answer">
                  <el-input
                    class="list-input"
                    :maxlength="200"
                    v-model.trim="otherForm.answer"
                    placeholder="请输入"
                    type="textarea"
                    :rows="5"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="list-two-line">
                <el-form-item label="机器人头像" prop="headPortrait">
                  <el-upload
                    class="list-upload-img"
                    :limit="1"
                    action="/api/blade-platform/questionbasicconfig/upload"
                    :data="{fileType:1}"
                    :on-preview="handlePictureCardPreview_S"
                    :on-remove="handleRemove_S"
                    :on-success="handleSuccess_S"
                    :on-error="hadleError_S"
                    :before-upload="beforeUpload_S"
                    :file-list="fileList_S"
                    accept=".jpg, .jpeg, .png, .gif"
                    list-type="picture-card"
                    :class="{hide:hideUpload_S}"
                  >
                    <i class="el-icon-plus"></i>
                    <div class="list-upload-title">点击上传</div>
                    <div
                      slot="tip"
                      class="list-upload-tip"
                    >5M以内，建议尺寸 255*255，支持扩展名.png、.jpg、.jpeg、.gif</div>
                  </el-upload>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <preview-modal
        :previewModal="dialogVisible"
        :previewImageUrl="dialogImageUrl"
        @previewClose="closePreview"
      ></preview-modal>
    </div>
  </div>
</template>

<script>
// import {
//   eduotheruserinfoDetailPort,
//   eduotheruserinfoSavePort,
//   eduotheruserinfoUpdatePort
// } from "@/api/c1.2/other.js";
// import myMixin from "@/mixins/pullList.js";
import { removeStore, getStore } from "@/utils/store";
import { mapState } from "vuex";
import { cloneDeep } from "lodash";
import { setRobotBasicInfoPort, getRobotBasicInfoPort } from "@/api/robotManage/basicInfo"
export default {
  //   mixins: [myMixin],
  name: "formSeven",
  data () {
    return {
      checkList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      pointList: [],
      rules: {
        name: [{ required: true, message: "请输入机器人名称", trigger: "blur" }],
        answer: [{ required: true, message: "请输入未知问题回答", trigger: "blur" }],
        headPortrait: [{ required: true, message: "请上传机器人头像", trigger: "change" }]
      },
      otherForm: {
        configId: '',
        answer: '',
        name: '',
        headPortrait: ''
      },
      originalData: {},
      title: "",
      rowData: null,
      countNum: 1, //用于显示第一个错误
      roleList: [], // 角色列表
      labelList: [], // 标签列表
      schoolList: [], // 校区列表
      fileList_S: [], //PC图
      uploadFilter: ['.jpg', '.jpeg', '.png', '.gif'],
      hideUpload_S: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  async created () {
      this.getBasicInfo()
  },
  methods: {
    //点击图片列表
    handlePictureCardPreview_S(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
      // console.log("点击了图片列表", file);
    },
    //移除
    handleRemove_S(file, fileList) {
      this.fileList_S = [];
      this.hideUpload_S = false;
      this.otherForm.headPortrait = "";
    },
    //上传之前
    beforeUpload_S(file) {
      this.hideUpload_S = true;
      let testSuffix = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      let res = this.filterFileRes(testSuffix, this.uploadFilter)
      if (!res) {
        this.$message.error('上传文件格式错误')
        return false
      }
      const imgsize = file.size / 1024 / 1024 <= 5;
      if (!imgsize) {
        this.$message.error("图片大小在5M以内，请重新上传！");
        return false;
      }
    },
    // 验证格式
    filterFileRes (testSuffix, uploadFilter) {
      let matchingCount = false
      uploadFilter.forEach(element => {
        // console.log(element)
        if (element === testSuffix) {
          matchingCount = true
        }
      })
      return matchingCount
    },
    // 成功
    handleSuccess_S(file) {
      console.log('file', file)
      this.otherForm.headPortrait = file.result
      this.fileList_S = [
          {
              url: file.result
          }
      ]
    //   this.formData.mobile_background = file.data[0].oUrl;
    },
    // 上传失败
    hadleError_S(err) {
      this.$message.error(err);
    //   this.fileList_S = []
    //   this.otherForm.headPortrait = ""
      this.hideUpload_S = false;
    },
    //---------------------------------------------------------------------
    // 关闭预览弹窗
    closePreview () {
      this.dialogVisible = false;
      this.dialogImageUrl = "";
    },
    reset () {
      this.getBasicInfo()
    },
    // 提交表单
    commit () {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.otherForm.validate(valid => {
          if (valid) {
            this.setBasicInfo()
          } else {
            return false;
          }
        });
      });
    },
    // 获取详情
    async eduotheruserinfoDetail () {
      //   const {
      //     data: { result, msg, status }
      //   } = await eduotheruserinfoDetailPort({
      //     otherUserId: this.rowData.otherUserId
      //   });
      //   if (status === 1000) {
      //     result.roleId = result.roleId == null ? [] : result.roleId.split(",");
      //     result.lableId = result.lableId == null ? [] : result.lableId.split(",");
      //     Object.assign(this.otherForm, cloneDeep(result));
      //     Object.assign(this.originalData, cloneDeep(result));
      //     return console.log(result);
      //   }
      //   this.$message.error(msg);
    },
    getCommitParams () {
      let cpData = cloneDeep(this.otherForm);
      console.log("cpData.roleId", cpData.roleId);
      cpData.roleId = cpData.roleId.filter(el => el).join(",");
      cpData.lableId = cpData.lableId.filter(el => el).join(",");
      if (this.rowData) {
        const data = {
          otherUserId: this.rowData.otherUserId,
          tenantId: this.userInfo.tenant_id,
          keyIds: this.rowData.keyId
        };
        return {
          ...data,
          ...cpData
        };
      }
      return {
        tenantId: this.userInfo.tenant_id,
        ...cpData
      };
    },
    // 新增其他用户
    async eduotheruserinfoSave () {
      //   const params = this.getCommitParams();
      //   const {
      //     data: { msg, status }
      //   } = await eduotheruserinfoSavePort(params);
      //   if (status === 1000) {
      //     this.$message.success("新增成功");
      //     this.changeComponent();
      //     return;
      //   }
      //   this.countNum = 1;
      //   this.$message.error(msg);
    },
    // 修改其他用户
    async eduotheruserinfoUpdate () {
      const params = this.getCommitParams();
      const {
        data: { msg, status }
      } = await eduotheruserinfoUpdatePort(params);
      if (status === 1000) {
        this.$message.success("修改成功");
        this.changeComponent();
        return;
      }
      this.countNum = 1;
      this.$message.error(msg);
    },
    // 改变index页面的component的值
    changeComponent () {
      this.$emit("changeComponent", "BasicPage");
      removeStore({
        name: "rowData",
        type: "session"
      });
    },
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 获取机器人基础信息
    async getBasicInfo() {
        const {
            data: {
                result, status, msg
            }
        } = await getRobotBasicInfoPort()
        if(status === 1000) {
            console.log('机器人基础信息', result)
            Object.assign(this.otherForm, result)
            if(result.headPortrait) {
                this.fileList_S = [{
                    url: result.headPortrait
                }]
                this.hideUpload_S = true;
            }
            return
        }
        return this.$message.error(msg)
    },
    // 设置机器人基础信息
    async setBasicInfo() {
        const {
            data: {
                status, msg
            }
        } = await setRobotBasicInfoPort({
            ...this.otherForm
        })
        if(status === 1000) {
            this.$message.success('保存成功')
            this.getBasicInfo()
            return
        }
        return this.$message.error(msg)
    }
  }
};
</script>
<style lang="scss">
.hide .el-upload--picture-card {
  display: none;
}
</style>
